import { http } from './request';
import type {
  Notification,
  NotificationListResponse,
  UnreadCountResponse,
  GetNotificationsParams,
} from '../types/notification';

export const notificationApi = {
  // 获取通知列表
  getNotifications: (params?: GetNotificationsParams) =>
    http.get<NotificationListResponse>('/api/v1/notifications', params as Record<string, unknown>),

  // 获取未读数
  getUnreadCount: () =>
    http.get<UnreadCountResponse>('/api/v1/notifications/unread-count'),

  // 标记通知已读
  markAsRead: (notificationId: string) =>
    http.put<{ message: string }>(`/api/v1/notifications/${notificationId}/read`),

  // 全部标记已读
  markAllAsRead: () =>
    http.put<{ message: string }>('/api/v1/notifications/read-all'),

  // 删除通知
  deleteNotification: (notificationId: string) =>
    http.delete<{ message: string }>(`/api/v1/notifications/${notificationId}`),
};
